import { trackMetaPixelViewContent } from './meta-pixel.es.js';

const trackViewProductDetail = (product) => {
  var _a;
  (_a = window.dataLayer) == null ? void 0 : _a.push({
    event: "viewDetail",
    ecommerce: {
      detail: {
        products: [product]
      }
    }
  });
  if (!!window.fbq) {
    const value = typeof product.price === "number" ? product.price : parseFloat(product.price) || 0;
    trackMetaPixelViewContent({
      content_ids: [product.sku],
      content_category: product.category || "",
      content_name: product.name || "",
      content_type: "product",
      contents: [{ id: product.sku, quantity: 1 }],
      currency: "VND",
      value
    });
  }
};
const trackViewProductList = (products) => {
  var _a;
  (_a = window.dataLayer) == null ? void 0 : _a.push({
    event: "viewListing",
    ecommerce: {
      impressions: products
    }
  });
};

export { trackViewProductDetail, trackViewProductList };
